import script from "./Article26.vue?vue&type=script&setup=true&lang=js"
export * from "./Article26.vue?vue&type=script&setup=true&lang=js"

import "./Article26.vue?vue&type=style&index=0&id=748fb2e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-748fb2e8"]])

export default __exports__